// [檔案： src/js/dom.js]

// --- 1. 導出一個空的物件 ---
export let dom = {};

// --- 2. 建立一個函數來填充這個物件 ---
export function initializeDOM() {
    dom = {
        // 月份
        currentMonthDisplay: document.getElementById('current-month'),
        monthPickerInput: document.getElementById('month-picker-input'), 
        prevMonthBtn: document.getElementById('prev-month'),
        nextMonthBtn: document.getElementById('next-month'),
        
        // 總覽
        currentBalanceEl: document.getElementById('current-balance'),
        
        // 列表
        transactionList: document.getElementById('transaction-list'),
        emptyState: document.getElementById('empty-state'),
        
        // 交易彈窗
        transactionForm: document.getElementById('add-transaction-form'),
        txModalTitle: document.getElementById('tx-modal-title'),
        txEditId: document.getElementById('tx-edit-id'), 
        txType: document.getElementById('tx-type'), 
        txTypeSlider: document.getElementById('tx-type-slider'),
        typeExpenseBtn: document.getElementById('type-expense-btn'),
        typeIncomeBtn: document.getElementById('type-income-btn'),
        txDate: document.getElementById('tx-date-picker'), 
        txCategory: document.getElementById('tx-category'),
        txCategoryBtn: document.getElementById('tx-category-btn'),
        txCategoryBtnText: document.getElementById('tx-category-btn-text'),
        txCategoryOptions: document.getElementById('tx-category-options'),
        txCategoryOptionItems: document.querySelectorAll('.tx-category-option'),
        txDescription: document.getElementById('tx-description'),
        txAmount: document.getElementById('tx-amount'),
        descriptionError: document.getElementById('description-error'),
        charCounter: document.getElementById('char-counter'),
        amountError: document.getElementById('amount-error'),
        saveTxBtn: document.getElementById('save-tx-btn'),
        
        // 訊息/確認 彈窗
        messageModal: document.getElementById('message-modal'),
        messageModalContent: document.getElementById('message-modal-content'),
        messageText: document.getElementById('message-text'),
        closeModalBtn: document.getElementById('close-modal'),
        confirmButtons: document.getElementById('confirm-buttons'),
        confirmOkBtn: document.getElementById('confirm-ok-btn'),
        confirmCancelBtn: document.getElementById('confirm-cancel-btn'),
        
        // 主題
        themeToggleModal: document.getElementById('theme-toggle-modal'),
        themeToggleHandle: document.getElementById('theme-toggle-handle'),
        themeIconSun: document.getElementById('theme-icon-sun'),
        themeIconMoon: document.getElementById('theme-icon-moon'),
        
        // Running Balance
        runningBalanceToggle: document.getElementById('running-balance-toggle'),
        runningBalanceHandle: document.getElementById('running-balance-handle'),
        
        // Font Size
        openFontSettingsBtn: document.getElementById('open-font-settings-btn'),
        fontSettingsView: document.getElementById('font-settings-view'),
        fontSettingsContent: document.getElementById('font-settings-content'),
        backFromFontBtn: document.getElementById('back-from-font-btn'),
        fontSizeOptions: document.querySelectorAll('.font-size-option'),
        
        // 底部導覽列按鈕
        navLedgerBtn: document.getElementById('nav-ledger-btn'),
        navSettingsBtn: document.getElementById('nav-settings-btn'),

        // 視圖容器
        ledgerView: document.getElementById('ledger-view'),
        userSettingsView: document.getElementById('user-settings-view'),
        userSettingsViewContent: document.getElementById('user-settings-view-content'),
        
        // 語言設定視圖
        languageSettingsView: document.getElementById('language-settings-view'),
        languageSettingsContent: document.getElementById('language-settings-content'),
        backFromLanguageBtn: document.getElementById('back-from-language-btn'),

        // 隱私權政策視圖
        privacyView: document.getElementById('privacy-view'),
        backFromPrivacyBtn: document.getElementById('back-from-privacy-btn'),
        openPrivacyBtn: document.getElementById('open-privacy-btn'),

        // Auth 彈窗 (OTP 改版)
        userIconStatus: document.getElementById('user-icon-status'), 
        userHeadStroke: document.getElementById('user-head-stroke'),
        userBodyStroke: document.getElementById('user-body-stroke'), 
        userFillShape: document.getElementById('user-fill-shape'),
        authModal: document.getElementById('auth-modal'),
        authModalContent: document.getElementById('auth-modal-content'),
        authModalTitle: document.getElementById('auth-modal-title'),
        closeAuthModalBtn: document.getElementById('close-auth-modal'),
        
        // Step 1: Email
        authStepEmail: document.getElementById('auth-step-email'),
        authEmail: document.getElementById('auth-email'),
        authMessageEmail: document.getElementById('auth-message-email'),
        getOtpBtn: document.getElementById('get-otp-btn'),
        iHaveCodeBtn: document.getElementById('i-have-code-btn'), 
        
        // Step 2: OTP
        authStepOtp: document.getElementById('auth-step-otp'),
        otpSentEmail: document.getElementById('otp-sent-email'),
        authOtp: document.getElementById('auth-otp'),
        authMessageOtp: document.getElementById('auth-message-otp'),
        verifyOtpBtn: document.getElementById('verify-otp-btn'),
        backToEmailBtn: document.getElementById('back-to-email-btn'),
        resendOtpBtn: document.getElementById('resend-otp-btn'), 
        resendTimer: document.getElementById('resend-timer'), 
        
        // 用戶設定
        settingsUserInfo: document.getElementById('settings-user-info'),
        settingsLoginBtn: document.getElementById('settings-login-btn'),
        settingsLogoutSection: document.getElementById('settings-logout-section'),
        logoutBtnModal: document.getElementById('logout-btn-modal'),
        settingsUserEmail: document.getElementById('settings-user-email'),
        exportDataBtn: document.getElementById('export-data-btn'),

        // 語言切換
        openLangModalBtn: document.getElementById('open-lang-modal-btn'),
        langBtnEn: document.getElementById('lang-en'),
        langBtnZhCN: document.getElementById('lang-zh-CN'),
        langBtnZhTW: document.getElementById('lang-zh-TW'),
        langBtnJa: document.getElementById('lang-ja'),
        langBtnKo: document.getElementById('lang-ko'),
        langBtnDe: document.getElementById('lang-de'),
        langBtnEs: document.getElementById('lang-es'),
        langBtnFr: document.getElementById('lang-fr'),
        langBtnPt: document.getElementById('lang-pt'),

        // 報表統計視圖
        openReportsBtn: document.getElementById('open-reports-btn'),
        reportsView: document.getElementById('reports-view'),
        backFromReportsBtn: document.getElementById('back-from-reports-btn'),
        reportPrevMonth: document.getElementById('report-prev-month'),
        reportNextMonth: document.getElementById('report-next-month'),
        reportMonthDisplay: document.getElementById('report-month-display'),
        reportTotalIncome: document.getElementById('report-total-income'),
        reportTotalExpense: document.getElementById('report-total-expense'),
        reportDailyAvgLabel: document.getElementById('report-daily-avg-label'),
        reportDailyAvg: document.getElementById('report-daily-avg'),
        reportDonutSvg: document.getElementById('report-donut-svg'),
        reportDonutLabel: document.getElementById('report-donut-label'),
        reportDonutValue: document.getElementById('report-donut-value'),
        reportMonthLabel: document.getElementById('report-month-label'),
        reportCategoryList: document.getElementById('report-category-list'),
        reportDailyChart: document.getElementById('report-daily-chart'),
        reportTabExpense: document.getElementById('report-tab-expense'),
        reportTabIncome: document.getElementById('report-tab-income'),
        reportCategoryTitle: document.getElementById('report-category-title'),
        reportTrendTitle: document.getElementById('report-trend-title'),

        // FAB & 新增彈窗
        openAddModalBtn: document.getElementById('open-add-modal-btn'),
        addTxModal: document.getElementById('add-tx-modal'),
        addTxModalContent: document.getElementById('add-tx-modal-content'),
        closeAddModal: document.getElementById('close-add-modal'),
        cancelAddBtn: document.getElementById('cancel-add-btn'),
        deleteTxBtnModal: document.getElementById('delete-tx-btn-modal'), 
    };

    // --- 3. 集中管理所有視圖 (方便批量隱藏/切換) ---
    // 以後新增頁面，只需加在這裡即可
    dom.views = [
        dom.ledgerView,
        dom.userSettingsView,
        dom.languageSettingsView,
        dom.fontSettingsView,
        dom.privacyView,
        dom.reportsView
    ].filter(el => el); // 過濾掉可能的 null (防止某個元素 ID 拼錯時崩潰)
}
